import { render, staticRenderFns } from "./FootbowlGame.vue?vue&type=template&id=1bd49fa0&"
import script from "./FootbowlGame.vue?vue&type=script&lang=ts&"
export * from "./FootbowlGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FootbowlGame.vue"
export default component.exports